import { tickerItems } from '@/mocks/home';

export default function TopTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-50">
      <div className="mx-auto flex h-9 max-w-none items-center gap-3 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-0.5 text-[11px] font-bold tracking-wide text-background-50">
          <span className="relative flex h-1.5 w-1.5">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50/80" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-background-50" />
          </span>
          更新
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-8 whitespace-nowrap">
            {loop.map((item, idx) => (
              <span key={idx} className="flex items-center gap-3 text-xs text-background-100/90">
                <i className="ri-arrow-right-up-line text-accent-300" />
                {item}
              </span>
            ))}
          </div>
        </div>
        <span className="hidden shrink-0 items-center gap-1.5 text-xs text-background-100/70 lg:flex">
          <i className="ri-shield-check-line text-accent-300" />
          官方签名校验 · 无捆绑
        </span>
      </div>
    </div>
  );
}